import { render, staticRenderFns } from "./zhiBoList.vue?vue&type=template&id=913c29d4&scoped=true"
import script from "./zhiBoList.vue?vue&type=script&lang=js"
export * from "./zhiBoList.vue?vue&type=script&lang=js"
import style0 from "./zhiBoList.vue?vue&type=style&index=0&id=913c29d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913c29d4",
  null
  
)

export default component.exports